module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    on: {
      "mouseover": function($event) {
        _vm.hovered(true)
      },
      "mouseleave": function($event) {
        _vm.hovered(false)
      },
      "click": function($event) {
        _vm.route(_vm.to)
      }
    }
  }, [_c('div', {
    ref: "parent",
    staticClass: " rectangle m-b-10 is-hoverable",
    class: {
      colored: _vm.isHovered, 'is-center': !_vm.top, 'is-top': _vm.top
    },
    style: ({
      background: ("url(" + (this.background) + ")"),
      'min-height': _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? _vm.height : '50vh',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute content-style is-hoverable",
    class: {
      hide: _vm.isHovered || _vm.isClicked, contact: _vm.$route.name === 'contact'
    },
    on: {
      "click": function($event) {
        _vm.route(_vm.to)
      }
    }
  }, [(_vm.$route.name === 'contact' && !_vm.isClicked) ? _c('h2', {
    staticClass: "title is-2 is-capitalized no-margin-bottom",
    class: _vm.red ? 'is-red' : 'is-white',
    on: {
      "click": function($event) {
        _vm.isClicked = !_vm.isClicked
      }
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'contact') ? _c('h2', {
    staticClass: "title is-2 is-capitalized no-margin-bottom",
    class: _vm.red ? 'is-red' : 'is-white'
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) && !_vm.html) ? _c('h3', {
    staticClass: "subtitle no-margin-top is-white is-5 "
  }, [_vm._v(_vm._s(_vm.subtitle) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) && _vm.html) ? _c('h3', {
    staticClass: "subtitle is-white is-5 no-margin-top relative",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isClicked && _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet) && _vm.$route.name === 'contact') ? _c('div', {
    staticClass: "is-white is-5 no-margin-top relative",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    },
    on: {
      "click": function($event) {
        _vm.isClicked = !_vm.isClicked
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.$route.name !== 'contact') ? _c('button', {
    staticClass: "is-bold is-white has-gradient-background button",
    on: {
      "click": function($event) {
        _vm.route(_vm.to)
      },
      "mouseover": function($event) {
        _vm.isHovered = true
      },
      "mouseleave": function($event) {
        _vm.isHovered = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d810e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/card.vue
// module id = 1136
// module chunks = 1